import accounts from 'accounts/Accounts.js';
import {getConfirmations} from './getConfirmations.js';
import {setPendingTransactions} from 'actions/index.js';
import contractMethods from './contractMethods.js';
import ethereum from 'decentralized/ethereum.js';

const WAIT_TIME = 30;

/**
 * Used for submitting ethereum transactions to the blockchain.
 * For example, when saving a new sequence, you run
 * new EthereumTransaction(TOKENIZED_SEQUENCES, 'editSequence', [arguments]).execute()
 * If metamask is installed, it will just call it w/in metamask. Otherwise it will pass
 * the json to the server to do so, along with the token
 */

class EthereumTransaction {
    constructor(contract, method, args, value) {
        this.contract = contract;
        this.method = method;
        this.arguments = args;
        this.value = value;
    }

    execute() {
        return new Promise(async (resolve, reject) => {
            const account = await accounts.getAccount();
            if (account === undefined) {
                reject();
                return;
            }
            if (ethereum.isMetamaskInstalled()) {
                // then just do the transaction via metamask
                let details = {
                    from: account
                };
                if (this.value) {
                    details.value = this.value;
                }
                contractMethods[this.contract][this.method](... this.arguments)
                    .send(details, (error, transactionHash) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve();
                    }
                });
            } else {
                console.log('runnign transaction');
                // have the server do it on the users behalf
                fetch('/transaction/' , {
                    method: 'POST',
                    body: JSON.stringify(this.getJson()),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }).then(async resp => {
                    console.log('returned =');
                    let {transactionHash} = await resp.json();
                    console.log('transaction hash = ' + transactionHash);
                    this.newPendingTransaction(transactionHash);
                    this.waitForConfirmation(transactionHash);
                    resolve();
                });
            }
        });
    }

    get transactions() {
        return ethereum.store.getState().transactions.pendingTransactions;
    }

    set transactions(t) {
        ethereum.store.dispatch(setPendingTransactions(t));
    }

    newPendingTransaction(txHash) {
        this.transactions = [... this.transactions,txHash];
    }

    waitForConfirmation(txHash, confirmations=1) {
        setTimeout(async () => {
            // Get current number of confirmations and compare it with sought-for value
            const trxConfirmations = await getConfirmations(txHash, ethereum.web3);
            if (trxConfirmations >= confirmations) {
                // Handle confirmation event according to your business logic
                this.onConfirm(txHash);
                return
            }
            // Recursive call
            return this.waitForConfirmation(txHash, confirmations)
        }, WAIT_TIME * 1000);
    }

    onConfirm(txHash) {
        let pending = [... this.transactions];
        let i = pending.indexOf(txHash);
        if (i > -1) {
            pending.splice(i, 1);
            this.transactions = pending;
        }
    }

    getJson() {
        return {
            contract: this.contract,
            method: this.method,
            arguments: this.arguments,
            token: accounts.getToken(),
            value: this.value,
        };
    }
}

export default EthereumTransaction;
